// extracted by mini-css-extract-plugin
export default {"objetGraphe":"ObjetGraphe_objetGraphe__Icj2R","FondImageGraphe":"ObjetGraphe_FondImageGraphe__ukmJ+"};